import Vue from 'vue'
import Vuex from 'vuex'
import { user } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null
  },
  mutations: {
    setUserInfo: function (state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    async fetchId ({ commit }, userId) {
      try {
        const { data } = await user.getAuthorization(userId)
        commit('setUserInfo', data)
      } catch (e) {
        commit('setUserInfo', null)
      }
    }
  },
  modules: {
  }
})
